/* eslint-disable no-undef */

APP.DetailPage = function () {
  new APP.AddonBar();
  this.topBar = new APP.TopBar('.top-bar');
  this.topBarContainer = this.topBar.getContainer();
  this.mobil = document.querySelector('.picture');
  this.header = document.querySelector('body header');
  this.screens = Array.prototype.slice.call(document.querySelectorAll('.screen'));
  this.osClass = APP.utils.getClientOsClass();

  /* STAV KOMPONENTY */
  this.callResizeActions = false;
  this.isSwiperInited = false;

  this.MAX_MOBILE_HEIGHT = 900;
  this.MAX_MOBILE_WIDTH = 900;

  this.swiperContainer = document.querySelector('.swiper-container');

  //na mobilu skryjeme v prvnim slidu ostatni platformy
  if (this.osClass) {
    APP.DetailPage.showActualPlatformLink(Array.prototype.slice.call(document.querySelectorAll('.column.title .store-links li')), this.osClass);
  }
  document.querySelector('.column.title .store-links').style.visibility = 'visible';

  this.swiper = new APP.Swiper(this.mobil, this.topBar, this.screens);

  this._attachEvents();
  this.init();
};

// eslint-disable-next-line no-unused-vars
APP.DetailPage.prototype.init = function (evt) {
  if (window.innerWidth >= APP.conf.breakPoints.tablet2Min) {
    this.swiper.init();
    this._resizeActions();

    setTimeout(
      function () {
        this.setMobileTop(this.mobil, Math.max(this.header.offsetHeight, (window.innerHeight - this.mobil.offsetHeight) / 2));
      }.bind(this),
      100
    );
  }
  this._tryInitLazyLoad();
};

APP.DetailPage.prototype._tryInitLazyLoad = function () {
  if (window.innerWidth < APP.conf.breakPoints.tablet2Min && !this.lazyLoad) {
    this.lazyLoad = new APP.LazyImages('.column.image img');
  }
};

APP.DetailPage.prototype.handleEvent = function (evt) {
  switch (evt.type) {
    case 'resize':
      if (this.onResize) {
        clearTimeout(this.onResize);
      }
      this.onResize = setTimeout(this.handleResize.bind(this), 100);
      break;
    default:
      return;
  }
};

APP.DetailPage.prototype._resizeActions = function () {
  APP.DetailPage.textCenter();
  this.mobileResize();
  this.mobileRight();
  this.swiper.setSlidesHeight();
  this.centerContent();
  setTimeout(
    function () {
      this.setMobileTop(this.mobil, Math.max(this.header.offsetHeight, (window.innerHeight - this.mobil.offsetHeight) / 2));
    }.bind(this),
    200
  );
};

APP.DetailPage.prototype.handleResize = function () {
  this.onResize = null;
  /* swiper v detailu od vyssiho rozliseni */
  if (window.innerWidth >= APP.conf.breakPoints.tablet2Min && !this.isSwiperInited) {
    this.swiper.init();
    this.callResizeActions = true;
    this.isSwiperInited = true;
  } else if (window.innerWidth < APP.conf.breakPoints.tablet2Min && this.isSwiperInited) {
    this.swiper.destroy();
    this.swiperContainer.style.height = 'auto';
    APP.DetailPage.textCenter();
    APP.DetailPage.textTop();
    this.callResizeActions = false;
    this.swiper._setSlidesAutoHeight();
    this.isSwiperInited = false;
  } else if (window.innerWidth < APP.conf.breakPoints.tablet2Min) {
    this.swiper.destroy();
    this.swiperContainer.style.height = 'auto';
    APP.DetailPage.textCenter();
    APP.DetailPage.textTop();
    this.callResizeActions = false;
    this.swiper._setSlidesAutoHeight();
    this.isSwiperInited = false;
  }

  this._tryInitLazyLoad();

  if (this.callResizeActions) {
    this._resizeActions();
  }
};

APP.DetailPage.prototype._attachEvents = function () {
  window.addEventListener('resize', this);
};

/* zmena vysky mobilu a screenu pokud jsou vyssi nez stranka bez topBaru */
APP.DetailPage.prototype.mobileResize = function () {
  if (this.MAX_MOBILE_HEIGHT > window.innerHeight - this.topBarContainer.offsetHeight) {
    var height = (window.innerHeight - this.topBarContainer.offsetHeight) * 0.9;
    var screens = Array.prototype.slice.call(this.mobil.querySelectorAll('img'));
    screens.forEach(function (screen) {
      screen.style.maxHeight = height + 'px';
    });
  }
};

/* priplacneme mobil doprava k textu - vse bude vycentrovano */
APP.DetailPage.prototype.mobileRight = function () {
  if (window.innerWidth / 2 > this.MAX_MOBILE_WIDTH) {
    this.mobil.style.right = document.querySelector('.column.text').offsetLeft + 'px';
  } else {
    this.mobil.style.right = 'auto';
  }
};

APP.DetailPage.prototype.centerContent = function () {
  var subTitleContainer = document.querySelector('.swiper-slide .subtitle-container');
  var bg = document.querySelector('.swiper-slide .top.detail');
  var space = this.mobil.offsetTop + this.mobil.offsetHeight - bg.offsetTop - bg.offsetHeight;
  space -= subTitleContainer.offsetHeight;
  // eslint-disable-next-line no-unused-vars
  space = space / 2;
};

APP.DetailPage.showActualPlatformLink = function (platforms, osClass, position) {
  platforms.forEach(function (link) {
    if (!link.classList.contains(osClass)) {
      link.classList.add('hidden');
    } else if (position === 'topBar') {
      link.classList.remove('no-margin');
    } else {
      link.classList.add('no-margin');
    }
  });
};

// eslint-disable-next-line no-unused-vars
var mobil = document.querySelector('.picture');

// eslint-disable-next-line no-shadow
APP.DetailPage.prototype.setMobileTop = function (mobil, top) {
  mobil.style.top = top + 'px';
};

APP.DetailPage.textCenter = function () {
  var slidesText = Array.prototype.slice.call(document.querySelectorAll('.swiper-slide .text'));
  slidesText.forEach(function (slide) {
    slide.style.marginTop = (window.innerHeight - slide.offsetHeight) / 2 + 'px';
  });
};

// eslint-disable-next-line no-unused-vars
APP.DetailPage.textTop = function (top) {
  var slidesText = Array.prototype.slice.call(document.querySelectorAll('.swiper-slide .text'));
  slidesText.forEach(function (slide, i) {
    // eslint-disable-next-line no-shadow
    var top = 112;
    if (i > 0) {
      top = 0;
    }
    slide.style.marginTop = top + 'px';
  });
};
